import { render, staticRenderFns } from "./fromBuilding.vue?vue&type=template&id=5819de24"
import script from "./fromBuilding.vue?vue&type=script&lang=js"
export * from "./fromBuilding.vue?vue&type=script&lang=js"
import style0 from "./fromBuilding.vue?vue&type=style&index=0&id=5819de24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports